import axios from "axios";
import {formDataHandler} from "@/services/form";
const errorsHandler = require("@/services/errors")

//Change This
const module = 'cancellations'

const state = {
    filter: {
        center_id : null,
        sport_id: null,
        status: null,
        refund_type: null,
        customer_q: null,
        created_from: null,
        created_to: null,
    },
    options_pagination: {
        page: 1,
        limit: 10
    },
}

const getters = {
    getFilter: state => {
        return state.filter
    },

    getOptionsPagination: state => {
        return state.options_pagination
    },
}

const actions = {
    index : async (context,payload) => {

        let url = `api/v1/${module}`;

        var params = ''

        params = `?page=${context.state.options_pagination.page}&limit=${context.state.options_pagination.limit}`

        if(context.state.filter.status){
            params += `&status=${context.state.filter.status}`
        }

        if(!context.rootGetters['user/getUser'].super_admin){
            params += `&center_id=${context.rootGetters['user/getUser'].center_id}`
        }

        if (context.state.filter.user_id && context.rootGetters['user/getUser'].super_admin) {
            params += `&user_id=${context.state.filter.user_id}`
        }

        if (context.state.filter.customer_q) {
            params += `&customer_q=${encodeURIComponent(context.state.filter.customer_q)}`;
        }
        if (context.state.filter.refund_type || context.state.filter.refund_type === false) {
            params += `&refund_type=${encodeURIComponent(context.state.filter.refund_type)}`;
        }
        if (context.state.filter.created_from) {
            params += `&created_from=${encodeURIComponent(context.state.filter.created_from)}`;
        }
        if (context.state.filter.created_to) {
            params += `&created_to=${encodeURIComponent(context.state.filter.created_to)}`;
        }

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}${params}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data.result

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    store : async (context,payload) => {

        let url = `api/v1/${module}/store/`;

        var formData = await formDataHandler(payload)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "multipart/form-data",
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    edit : async (context,payload) => {

        let url = `api/v1/${module}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    update : async (context,payload) => {

        let url = `api/v1/${module}/update/${payload.id}`;

        var formData = await formDataHandler(payload.item)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    delete : async (context,payload) => {

        let url = `api/v1/${module}/delete/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,{},{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    massDelete : async (context,payload) => {

        let url = `api/v1/${module}/mass-delete`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,payload,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },

    setFilter: async (context,value) => {
        context.commit('SET_FILTER', value)
    },

    setOptionsPagination: async (context,value) => {
        context.commit('SET_OPTIONS_PAGINATION', value)
    },
}

const mutations = {
    SET_FILTER: (state, value) => {
        state.filter = value
    },
    SET_OPTIONS_PAGINATION: (state, value) => {
        state.options_pagination = value
    },
}


export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}

